import { useSelfcareAuth } from 'routes/selfcare/auth/useSelfcareAuth'
import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useApp } from 'store/steps'

export const SelfcareProtectedRoute: FC = () => {
    const { isAuthenticated, isLoading } = useSelfcareAuth()
    const { getPath } = useApp()

    return isAuthenticated && !isLoading ? (
        <Outlet />
    ) : (
        <Navigate to={getPath('selfcare_login')} replace />
    )
}
